<script>
import formatDate from "@utils/format-date";
import formatCurrency from "@utils/format-currency";
import formatServiceTime from "@utils/format-service-time";
import { authComputed, merchantComputed } from '@store/helpers'
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";
import { getDefaultReservationDisabledDayList } from "@utils/ipetbooking-get-default";
import getISODay from "date-fns/getISODay";
import parseISO from "date-fns/parseISO";
import { getStoreOption } from "@utils/ipetbooking-options";
// import  { formatOrder } from "@utils/format-order";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";
import {
  orderIsUseDeduct,
  orderIsPrepaidUnpaidAndDeduct,
  orderBillingReservationList,
  orderReserveParamsList
} from "@utils/ipetbooking-order";


export default {
  name:'InfoBox2',
  components: {
    // FormCoupon: () => import("@components/Form/FormCoupon"),
  },
  props: {
    cart: {
      type: Object,
      default: () => {
        return {}
      }
    },
    submitData: {
      type: Object,
      required: true
    },
    cartTotal: {
      type: Number,
      required: true
    },
    isFreeOrder: {
      type: Boolean,
      required: true
    },
    isUnpaid: {
      type: Boolean,
      required: true
    },
    showCoupon: {
      type: Boolean,
      required: true
    },
    couponDiscount: {
      type: Number,
      required: true
    },
    prepaidInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    invalid: {
      type: Boolean,
      default: false
    },
    formatSubmitText: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isActive: 0
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    isUseDeduct() {
      return orderIsUseDeduct({ ...this.orderItem })
    },
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.orderItem })
    },
    // billList() {
    //   if(this.isUnpaid) {
    //     return orderBillingReservationList({
    //       type: 'memberOrder',
    //       ...this.cart,
    //       isUnpaidAndDeduct: this.isUnpaidAndDeduct
    //     });
    //   } else {
    //     return conditionList([
    //       {
    //         title: `${this.submitData.param.qty}<i class="fontello ${this.$globalIsDingBeauty ? 'fontello-db-lipstick fs-lg' : 'fontello-paw'} fa-fw ml-2 text-primary"></i>`,
    //         text: `${
    //             this.isHasMemberLevel ? 
    //             `<span class="">
    //               會員價：NT$ ${formatCurrency(this.submitData.param.price - Math.round( this.submitData.param.price * (this.memberLevelDiscount / 100)) )}
    //             </span>
    //             <br>
    //             <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：${formatCurrency(this.submitData.param.price)}</span>`
    //             : `NT$ ${formatCurrency(this.submitData.param.price)}`
    //           }`,
    //         textClass: 'font-number'
    //       },
    //       {
    //         type: 'hr'
    //       },
    //       {
    //         title: '小計',
    //         text: `NT$ ${formatCurrency(this.submitData.param.price - Math.round(this.submitData.param.price * (this.memberLevelDiscount / 100)))}`,
    //         textClass: 'font-number'
    //       },
    //       {
    //         title: `${this.prepaidInfo.prepaid && this.prepaidInfo.prepaid.title
    //           ? this.prepaidInfo.prepaid.title
    //           : `${this.currentMerchant.prepaidSetting.title || '包套方案'}`}`,
    //         text: `- NT$ ${formatCurrency(this.submitData.param.price - Math.round( this.submitData.param.price * (this.memberLevelDiscount / 100) ))}`,
    //         class: 'text-danger',
    //         textClass: 'font-number',
    //         condition: () => {
    //           return !!Object.keys(this.prepaidInfo)[0];
    //         },
    //       },
    //       {
    //         title: `優惠券 (${this.submitData.couponInfo.title}：${this.submitData.couponInfo.code}）`,
    //         text: `- NT$ ${formatCurrency(this.couponDiscount)}`,
    //         class: 'text-danger',
    //         textClass: 'font-number',
    //         condition: () => {
    //           return !!this.submitData.couponInfo.title;
    //         },
    //       },
    //       {
    //         type: 'slot',
    //         slot: 'coupon',
    //         condition: () => {
    //           const isCheckoutDetail = this.$route.name.includes('-checkout-detail');
    //           return this.showCoupon && !isCheckoutDetail;
    //         },
    //       },
    //       {
    //         type: 'hr'
    //       },
    //       {
    //         title: '總計',
    //         text: formatPrice(this.cartTotal),
    //         class: 'align-items-end',
    //         textClass: 'text-primary-dark font-number fw-semi-bold fs-xl'
    //       },
    //     ]);
    //   }
    // },
    disabledDayList() {
      return this.cartType === 'reservation'
        ? getDefaultReservationDisabledDayList({
          storeAlias: this.submitData.param.store.alias,
          type: 'element'
        })
        : []
    },
    isIncludDisabledDayList() {
      return this.cartType === 'reservation' && this.submitData.date
        ? this.disabledDayList.includes(getISODay(parseISO(this.submitData.date)).toString())
        : false;
    },
    data: {
      get() {
        return this.submitData
      },
      set(value) {
        this.$emit('update:submitData', value);
      }
    },
    activePrice: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    storeItem() {
      return getStoreOption({
        value: this.submitData.storeAlias,
        type: 'item'
      })
    },
    // isHasMemberLevel() {
    //   if (!this.isMemberLevelEnabled || !this.isLoggedIn) return false
    //   return !!this.currentMember?.level && this.memberLevelDiscount > 0
    // },
    total() {
      let price = 0;
      this.submitData.orders.items.forEach((item) => {
        price += this.totalPrice(item.params)
      })
      return price
    },
    orderBillingTotal() {
      const priceTotal = this.submitData.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0);
      return conditionList([
        {
          title: '小計',
          text: `${formatPrice(priceTotal)}`,
          textClass: 'font-number',
        },
        ...this.formatBillList(this.cart.params)
      ])
    },
    submitInvalid() {
      if((this.submitData.paymentMethod === 'Credit' && !this.submitData.expYear) 
      || (this.submitData.paymentMethod === 'Deposit' && this.currentMember.point < this.cartTotal)) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.initDefaultShowListHeight()
    }, 500)
    
  },
  methods: {
    formatPrice,
    formatDate,
    formatServiceTime,
    formatCurrency,
    memberLevelPriceDiscount,
    onSubmit() {
      this.$emit('submit')
    },
    formatBillList(params) {
      const paramsList = (typeList) => {
        return orderReserveParamsList({
          typeList,
          params,
        });
      };
      const result = [
        ...paramsList(['cosmetic','daycare','prepaid', 'coupon']),
        ...paramsList(['daycare-add','cosmetic-add', '+', '-', '%'])
      ]
      return result
    },
    totalPrice(item) {
      return item.reduce((acc, cur) => {
        acc += cur.total
        return acc
      }, 0)
    },
    initDefaultShowListHeight() {
      const offsetHeight = this.$refs[`ordersItem-${this.isActive}`][0].offsetHeight
      this.$refs[`ordersItem-${this.isActive}`][0].style.height =`${offsetHeight}px`
    },
    isShow(index) {
      this.isActive = index
    },
    onBeforeEnter(el) {
      el.style.display = 0;
      el.style.height = 0;
    },
    onEnter(el) {
      el.style.height= `${el.children[0].offsetHeight}px`
    },
    onLeave(el) {
      el.style.height = 0;
      el.style.padding = 0;
    },
    isChangePrice(item) {
      return ['+','-','%'].includes(item.category)
    },
  }
}
</script>
<!-- section template -->
<template>
<div>
  <div :class="$style.infoBoxReservation">
    <h4 class="mb-4">訂單摘要</h4>
    <div
      :class="$style.ordersList"
    >
      <div
        v-for="(item, index) in submitData.orders.items"
        :key="`ordersItem-${index}`"
        class="ordersItem__item"
      >
        <div 
          class="ordersItem__title d-flex align-items-center justify-content-between"
          :class="{ 'isActive': isActive === index }"
          @click="isShow(index)"
        >
          <div>
              <i v-if="!$globalIsDingBeauty" class="fontello fontello-paw fs-base mr-2 text-primary"></i> 
              <i v-else class="fontello fontello-db-lipstick fs-lg mr-2 text-primary"></i> 
              <span class="text-primary fs-sm mr-3">{{item.pet.name}}</span>
          </div>
          <div class="ordersItem__icon">
            <i class="fal fa-angle-right"></i>
          </div>
        </div>
          <transition
            name="slide" 
            @enter="onEnter"
            @leave="onLeave"
            @before-enter="onBeforeEnter"
          >
          <div
            v-show="isActive === index "  
            :ref="`ordersItem-${index}`" 
            class="ordersItem__contentBox"
            :class="{ 'isActive': isActive === index }"
            :style="{ 'height: 0; padding: 0': isActive !== index }"
          >
            <ul class="ordersItem__contentList">
              <li v-for="(item2, index2) in formatBillList(item.params)" :key="index2" class="ordersItem__contentItem">
                <div :class="item2.class" >{{item2.title}}</div>
                <div 
                  v-if="item2.type === 'prepaid' || isChangePrice(item2)"
                  :class="item2.class" 
                  class="ordersItem__contentPrice font-number"
                >
                  {{ item2.text }}
                </div>
                <div v-else :class="item2.class" class="ordersItem__contentPrice font-number">
                  {{ item2.total > 0 ? `${item2.qty} x` : '' }}
                  <template v-if="item2.levelDiscount > 0">
                    NT$ {{ memberLevelPriceDiscount(item2.price, item2) }} 
                  </template>
                  <template v-else>
                    NT${{ formatCurrency(item2.price) }}
                  </template>
                </div>
              </li>
            </ul> 
          </div>
        </transition>
        <div class="ordersItem__total d-flex align-items-center justify-content-between">
          <span>小計</span>
          <span>{{ formatPrice(totalPrice(item.params)) }}</span>
        </div>
      </div>
    </div>
    <template v-if="!!cart.params.length">
      <hr>
      <BaseList
        :data-list="orderBillingTotal"
        class="px-md-4 px-2"
        type="order"
      >
        <!-- <FormCoupon
          slot="coupon"
          v-model="data"
          class="mt-2"
          :cart="cart"
          :is-unpaid="isUnpaid"
        /> -->
      </BaseList>
    </template>
    <hr >
    <div class="infoBoxReservation__total d-flex align-items-center justify-content-between">
      <span>總計</span>
      <span class="text-primary-dark fs-xl">{{ formatPrice(cartTotal) }}</span>
    </div>
    <BaseButton
      v-if="!$globalIsDingBeauty"
      :disabled="invalid || submitInvalid"
      class="isStylePrimary isFull d-none d-md-block isRadius"
      @click="onSubmit"
    >
      <div class="">
        <span>{{ formatSubmitText }}</span>
      </div>
    </BaseButton>
  </div>
  <BaseButton
    v-if="$globalIsDingBeauty"
    :disabled="invalid || submitInvalid"
    class="isStylePrimary isFull d-none d-md-block"
    @click="onSubmit"
  >
    <div class="d-flex justify-content-between align-items-center pt-1 px-2">
      <span>{{ formatSubmitText }}</span>
      <span><i class="fontello fontello-arrow-right-helf fs-4xl"></i></span>
    </div>
  </BaseButton>
</div>
</template>
<!-- section style -->
<style lang="scss" module>
.infoBoxReservation {
  padding: 2.25rem 1.875rem;
  background: #FFF;
  box-shadow: 2px 8px 36px #1C2C5414;

  @include max-md {
    border-bottom: $color-gray-4 1px solid;
    border-radius: 0;
    box-shadow: none;
  }

  :global {
    .infoBoxReservation {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.125rem;
        font-weight: 600;
      }

      &__info {
        margin-bottom: 2rem;
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
      }
      &__total {
        padding: 0 0 1.25rem;
        font-size: 0.875rem;
        color: $color-gray-2;
      }
    }
  }
  .ordersList {
    :global {
      .ordersItem {
        &__item {
          padding: 0 1.25rem;
          background: rgba($color-primary, 10%);
          &:not(:last-child) {
            margin-bottom:  1rem;
          }
        }
        &__title {
          padding: 1.25rem 0;
          cursor: pointer;
          .ordersItem__icon {
            i {
              color: $color-gray-2;
              font-size: 1.5rem;
              transition: .3s;
            }
          }
          &.isActive {
            .ordersItem__icon {
              i {
                transform: rotate(90deg);
              }  
            }
          }
        }
        &__contentBox {
          overflow: hidden;
          transition: .3s;
          // will-change: height;

         
        }
        &__contentList {
          font-size: 0.875rem;
          padding: 0 0 1.25rem;
          color: $color-gray-2;
          @include list-unstyled();
        }
        &__contentItem {
          display: flex;
          justify-content: space-between;
          &:not(:last-child) {
            margin-bottom: 8px;
          }
        }
        &__contentPrice {
          flex-shrink: 0;
          margin-left: 1rem;
        }
        &__total {
          border-top: 1px solid $color-line;
          padding: 1.25rem 0;
          font-size: 0.875rem;
          color: $color-gray-2;
        }
      }
    }
  }
  :global {
    .slide-leave-active,
    .slide-enter-active {
      // transition: height 10s ease;
    }
    .slide-enter-from {
      // height: 0;
    }
    .slide-leave-to {
      height: 0;
      // height: 300px;
    }
  }
 
}
</style>
